import React from 'react';
import ReactDOM from 'react-dom/client';
import 'flag-icons/css/flag-icons.min.css';
import './index.css';
import App from './App';
import { redirectToCanonicalHostIfNeeded } from './utils/canonicalHost';

// www and apex are different origins — force scoreclash.app so sessions cannot diverge.
if (redirectToCanonicalHostIfNeeded()) {
  // Navigation in progress; skip mounting the app on the non-canonical host.
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

